import { useEffect, useState } from 'react';
import { AbortRequestError } from '@sitecore-search/core';
import { useQueryClient, useQuery as useReactQuery } from '@tanstack/react-query';
const useQuery = (query) => {
    const [requestKey, setRequestKey] = useState(() => query.getKey());
    const queryClient = useQueryClient();
    useEffect(() => {
        query.onUpdate(() => {
            setRequestKey(query.getKey());
        });
        return () => {
            query.destroy();
        };
    }, [query]);
    return useReactQuery({
        queryKey: requestKey,
        queryFn: (context) => {
            return query.run().catch((error) => {
                if (error instanceof AbortRequestError) {
                    return queryClient.cancelQueries({ queryKey: context.queryKey, exact: true }).then(() => null);
                }
                return Promise.reject(error);
            });
        },
        refetchOnMount: false,
        enabled: query.isEnabled(),
    });
};
export default useQuery;
